import React from 'react'
import styles from './AnimatedWaitIcon.module.scss'
import clsx from 'clsx'

type AnimatedWaitIconAnimationType = 'fade' | 'bounce'

export interface AnimatedWaitIconProps {
    className?: string
    animationType: AnimatedWaitIconAnimationType
    size?: 'default' | 'large'
}

export function AnimatedWaitIcon({className, animationType, size = 'default'}: AnimatedWaitIconProps) {
    return (
        <div className={clsx(styles.ellipsis, styles[animationType], styles[size], className)}>
            <div className={styles.dot}></div>
            <div className={styles.dot}></div>
            <div className={styles.dot}></div>
        </div>
    )
}
